import { PublicEWebinarFragment } from '../typesProxy';

export type EwebinarFragmentForSessions = Pick<
  PublicEWebinarFragment,
  | 'timeZone'
  | 'startDate'
  | 'endDate'
  | 'endDateEnabled'
  | 'scheduleSettings'
  | 'justInTimeModeEnabled'
  | 'oneTimeEvent'
  | 'viewerRoomSettings'
  | 'fullSessions'
>;

export const RETARGETED_VISITOR_FNAME = 'Attendee';
